import { Component, Input } from '@angular/core';
import { LoadingIndicatorComponent } from '../../../core/components/loading-indicator/loading-indicator.component';

@Component({
  selector: 'app-dashboard-frame',
  standalone: true,
  imports: [
    LoadingIndicatorComponent
  ],
  templateUrl: './dashboard-frame.component.html',
  styleUrl: './dashboard-frame.component.scss'
})
export class DashboardFrameComponent {
  @Input() title?: string;
  @Input() showHoverOver?: boolean | undefined = true;
  @Input() isLoading: boolean = false;
  @Input() loadingMessage: string = 'Loading...';


}
